module.exports = __webpack_public_path__ + "img/menu-icon-tnc-circle.45dde9d4.svg";